import { useMemo } from 'react';

import { usePredictionsInfoContext } from '../../../../context/predictions-info-context';

export const useFRAccountNames = () => {
  const { forecastReportV2: forecastReport } = usePredictionsInfoContext();

  const index = useMemo(() => {
    const index: Record<string, string> = {};

    if (forecastReport) {
      // Run through all nodes and create account name index
      Object.entries(forecastReport.node_info.by_ref).forEach(([ref, node]) => {
        index[ref] = `${node.code || ''} ${node.name}`.trim();
      });
    }

    return index;
  }, [forecastReport]);

  return index;
};
